// Copyright (c) 2019 Deere & Company

import './index.scss';

import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    addBaseCode, addProductSeries, addProductSubSeries,
    deleteBaseCode, deleteProductSeries, deleteProductSubSeries,
    editBaseCode, editProductSeries, editProductSubSeries,
    getAdminReport, getAdminReportDownload, getBaseCodeSearchResult,
    getProductSubSeries, getProductSubSeriesById,
} from '../../repositories';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import {
    getDefaultMode, getModePrefix, getNextMode, getPreviousMode,
} from './services/modes';
import BasecodeSearchPanel from '../basecode-search-panel';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
//import CSVFile from '../../../assets/warranty_prodct_structure.csv';
import { ConfirmationModal } from '../../../shared/components/modals/confirmation-modal';
// import MultipleEntryPopup from './multiple-entry-popup';
import ProductSeriesPanel from '../product-series-panel';
import PropTypes from 'prop-types';
import SearchBarWidget from '../../../shared/components/search-bar-widget';
import WPSMAside from './aside';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../../shared/services/customize-error-alert-bar';
import { downloadSampleReports, getBaseCodes } from '../../../claims/repositories';
import { getProductSeries } from '../../../app/common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import WarrantyProductStructMultipleEntryPopup from './warranty-product-struct-multiple-entry-popup';


export class WarrantyProductStructureMaintenance extends Component {

    delayTimer = null;

    state = {
        baseCodes: [],
        mode: getDefaultMode(),
        id: 0,
        isEdit: false,
        editText: '',
        editId: 0,
        editMode: getDefaultMode(),
        currentBaseCode: {},
        selectedBaseCode: {},
        confirmMessage: '',
        confirmTitle: '',
        confirmIsOpen: false,
        searchedText: '',
        searchPlaceHolder: 'Search BMC',
        modelIsOpen: false,
        modelIsClose: false,
    };


    componentWillMount = () => {

        this.loadDefault();


    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'warranty' ) {

            this.loadDefault();
            nextProps.updateReload();

        }

    }

    componentDidUpdate = prevProps => {

        if ( prevProps.factoryCode !== this.props.factoryCode ) {

            this.loadDefault();

        }

    }

    loadDefault = () => {

        if ( this.props.factoryCode ) {

            this.props.increaseCounter();
            getProductSeries( this.props.factoryCode ).then( response => {

                this.setState( {
                    baseCodes: response,
                    mode: getDefaultMode(),
                    id: 0,
                    isEdit: false,
                    confirmIsOpen: false,
                    selectedBaseCode: {},
                    currentBaseCode: {},
                    searchedText: this.state.searchedText.length === 0 ? '' : this.state.searchedText,
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }


    handleSearchChange = searchText => {

        this.setState( {
            searchedText: searchText,
        } );

        if ( searchText.length >= 3 ) {

            const fc = this.props.factoryCode;
            const increaseCntr = () => {

                this.props.increaseCounter();

            };
            const decreaseCntr = () => {

                this.props.decreaseCounter();

            };

            const newStateResponse = ( searchedText, response ) => {

                if ( this.state.mode === 'SEARCH' && searchedText.toUpperCase() === this.state.searchedText.toUpperCase() ) {

                    this.setState( {
                        baseCodes: response,
                        mode: 'SEARCH',
                        searchedText,
                        confirmIsOpen: false,
                    } );

                }

            };


            clearTimeout( this.delayTimer );
            this.delayTimer = setTimeout( () => {

                increaseCntr();
                this.setState( {
                    mode: 'SEARCH',
                    searchedText: searchText,

                }, () => {


                    getBaseCodeSearchResult( fc, searchText.toUpperCase() ).then( response => {

                        newStateResponse( searchText, response );
                        decreaseCntr();

                    } ).catch( () => {

                        decreaseCntr();

                    } );

                } );

            }, 500 );


        } else {

            clearTimeout( this.delayTimer );
            this.loadDefault();

        }

    }


    handleModeChange = ( mode, obj ) => {

        if ( mode === '' ) {

            this.loadDefault();

        } else {

            const nextMode = getNextMode( mode );
            this.setState( {
                // mode: nextMode,
                id: obj[`${getModePrefix( mode )}Id`],
                isEdit: false,
                confirmIsOpen: false,
            } );

            if ( nextMode === 'SUBSERIES' ) {

                this.props.increaseCounter();
                getProductSubSeries( this.props.factoryCode, obj[`${getModePrefix( mode )}Id`] ).then( response => {

                    this.setState( {
                        baseCodes: response,
                        mode: nextMode,
                        isEdit: false,
                        confirmIsOpen: false,
                        currentBaseCode: obj,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

            if ( nextMode === 'BASECODE' ) {

                this.props.increaseCounter();
                getBaseCodes( this.props.factoryCode, obj.productSeriesId, obj[`${getModePrefix( mode )}Id`] ).then( response => {

                    this.setState( {
                        baseCodes: response,
                        mode: nextMode,
                        currentBaseCode: obj,
                        editId: obj.productSubSeriesId,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }

    }

    handleEditClick = ( mode, id, name ) => {

        const editMode = mode;
        const obj = this.state.currentBaseCode;
        if ( mode === 'BASECODE' ) {

            this.props.increaseCounter();
            getProductSeries( obj.factoryCode ).then( seriesresponse => {

                this.props.increaseCounter();
                getProductSubSeries( obj.factoryCode, obj.productSeriesId )
                    .then( subseriesresponse => {

                        this.setState( {
                            selectedBaseCode: obj,
                            isEdit: true,
                            editId: id,
                            editMode: mode,
                            productserieslist: seriesresponse,
                            productSubSeriesList: subseriesresponse,
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else {

            this.setState( {
                isEdit: true,
                confirmIsOpen: false,
                editText: name,
                editId: id,
                editMode,
            } );

        }

    };

    handleDeleteClick = mode => {

        this.setState( {
            mode,
            confirmMessage: 'Are you sure you want to Delete?',
            confirmIsOpen: true,
            confirmTitle: 'Confirm Delete?',
        } );

    }

    handleBaseCodeSelect = obj => {

        this.props.increaseCounter();
        getProductSeries( obj.factoryCode ).then( seriesresponse => {

            this.props.increaseCounter();
            getProductSubSeries( obj.factoryCode, obj.productSeriesId ).then( subseriesresponse => {

                this.setState( {
                    selectedBaseCode: obj,
                    isEdit: true,
                    editId: obj.baseCodeId,
                    editMode: 'BASECODE',
                    confirmIsOpen: false,
                    productserieslist: seriesresponse,
                    productSubSeriesList: subseriesresponse,
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleAsideTextChange = ( props, event ) => {

        const desired = props.editMode === 'SERIES' ? event.target.value.replace( /[^\w]/gi, '' ) : event.target.value.replace( /[^\w\s()]/gi, '' );

        this.setState( {
            editText: desired,
        } );

    };

    handleAsideCancel = () => {

        this.setState( {
            isEdit: false,
        } );

    };

    handleAsideUpdate = () => {

        if ( this.state.editId === -1 ) {

            if ( this.state.editMode === 'SERIES' ) {

                this.props.increaseCounter();
                addProductSeries( this.props.factoryCode, this.state.editText ).then( response => {

                    if ( response.productSeriesName === this.state.editText ) {

                        this.handleModeChange( '', {} );

                    }
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Add New Product Series Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }
            if ( this.state.editMode === 'SUBSERIES' ) {

                this.props.increaseCounter();
                addProductSubSeries( this.props.factoryCode, this.state.currentBaseCode,
                    this.state.editText ).then( response => {

                    if ( response.productSubSeriesName === this.state.editText ) {

                        this.handleModeChange( 'SERIES', this.state.currentBaseCode );

                    }
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Add New Product Subseries Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }
            if ( this.state.editMode === 'BASECODE' ) {

                this.props.increaseCounter();
                addBaseCode( this.props.factoryCode, this.state.selectedBaseCode )
                    .then( response => {

                        if ( !this.state.searchedText ) {

                            this.handleModeChange( 'SUBSERIES', this.state.selectedBaseCode );

                        } else {

                            this.handleSearchChange( this.state.searchedText );

                        }
                        this.setState( {
                            selectedBaseCode: response,
                        } );
                        this.props.decreaseCounter();
                        this.props.createSuccessMessage( 'Add New Basecode Successful' );

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

            }

        } else {

            if ( this.state.editMode === 'SERIES' ) {

                this.props.increaseCounter();
                editProductSeries( this.props.factoryCode, this.state.editId,
                    this.state.editText ).then( response => {

                    const curObj = this.state.currentBaseCode;
                    curObj.productSeriesName = response.productSeriesName;

                    this.setState( {
                        currentBaseCode: curObj,
                        selectedBaseCode: {},
                    } );
                    this.handleModeChange( getPreviousMode( this.state.mode ),
                        this.state.currentBaseCode );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Update Product Series Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }
            if ( this.state.editMode === 'SUBSERIES' ) {

                this.props.increaseCounter();
                editProductSubSeries( this.props.factoryCode, this.state.currentBaseCode,
                    this.state.editId, this.state.editText ).then( response => {

                    const curObj = this.state.currentBaseCode;
                    curObj.productSubSeriesName = response.productSubSeriesName;

                    this.setState( {
                        currentBaseCode: curObj,
                        selectedBaseCode: {},
                    } );
                    this.handleModeChange( getPreviousMode( this.state.mode ),
                        this.state.currentBaseCode );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( '"Update Product Subseries Successful"' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }
            if ( this.state.editMode === 'BASECODE' ) {

                this.props.increaseCounter();
                editBaseCode( this.state.selectedBaseCode ).then( response => {

                    if ( !this.state.searchedText ) {

                        this.handleModeChange( 'SUBSERIES', this.state.selectedBaseCode );

                    } else {

                        this.handleSearchChange( this.state.searchedText );

                    }
                    this.setState( {
                        selectedBaseCode: response,
                        isEdit: false,
                    } );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Update Base Code Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }

    }

    handleSeriesOnChange = obj => {

        this.props.increaseCounter();
        getProductSubSeries( this.props.factoryCode, obj ).then( subseriesresponse => {

            if ( subseriesresponse && subseriesresponse.length > 0 ) {

                subseriesresponse.forEach( resData => {

                    const curObj = { ...this.state.selectedBaseCode };
                    curObj.productSubSeriesName = resData.productSubSeriesName;
                    curObj.productSubSeriesId = resData.productSubSeriesId;
                    curObj.productSeriesName = resData.productSeriesName;
                    curObj.productSeriesId = resData.productSeriesId;
                    this.setState( {
                        selectedBaseCode: curObj,
                        id: curObj.baseCodeId,
                        productSubSeriesList: subseriesresponse,
                    } );
                    this.props.decreaseCounter();

                } );

            } else {

                this.setState( {
                    productSubSeriesList: [],
                } );
                this.props.decreaseCounter();

            }

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleSubSeriesOnChange = subseriesId => {

        this.props.increaseCounter();
        getProductSubSeriesById( subseriesId ).then( subseriesresponse => {

            const curObj = this.state.selectedBaseCode;
            curObj.productSubSeriesId = subseriesId;
            curObj.productSubSeriesName = subseriesresponse.productSubSeriesName;
            this.setState( {
                selectedBaseCode: curObj,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleBMCNameOnChange = baseCodeName => {

        const desired = baseCodeName.replace( /[^\w\s]/gi, '' ).trim();
        const curObj = this.state.selectedBaseCode;
        curObj.baseCodeName = desired;
        this.setState( {
            selectedBaseCode: curObj,
        } );

    }

    handleBaseCodeAddClick = () => {

        const curObj = this.state.currentBaseCode;
        curObj.factoryCode = this.props.factoryCode;
        curObj.baseCodeName = '';
        curObj.baseCodeId = '';
        this.props.increaseCounter();

        getProductSeries( this.props.factoryCode ).then( seriesresponse => {

            if ( seriesresponse.length === 0 ) {

                customizeErrorAlert( 'Please Add Atleast One Product Series to Create New BMC”' );
                this.props.decreaseCounter();
                return false;

            }


            let productSeriesId = '';
            if ( curObj.productSeriesId ) {

                productSeriesId = curObj.productSeriesId;

            } else {

                productSeriesId = seriesresponse[0].productSeriesId;

            }
            this.props.increaseCounter();
            getProductSubSeries( this.props.factoryCode, productSeriesId )
                .then( subseriesresponse => {

                    this.setState( {
                        editMode: 'BASECODE',
                        selectedBaseCode: curObj,
                        isEdit: true,
                        editId: -1,
                        productserieslist: seriesresponse,
                        productSubSeriesList: subseriesresponse,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleConfirmClose = () => {

        this.setState( {
            confirmIsOpen: false,
        } );

    }

    onUploadReport = () => {

        this.setState( {
            modelIsOpen: true,
        } );

    }

    onUploadReportClose = () => {

        this.setState( {
            modelIsOpen: false,
        } );

    };

    handleConfirm = () => {


        const obj = this.state.currentBaseCode;
        if ( ( this.state.mode === 'BASECODE' || this.state.mode === 'SEARCH' )
          && this.state.isEdit
         && this.state.editMode === 'BASECODE' ) {

            const curObj = this.state.currentBaseCode;
            curObj.baseCodeName = '';
            curObj.baseCodeId = '';
            this.props.increaseCounter();
            deleteBaseCode( this.props.factoryCode,
                this.state.selectedBaseCode.baseCodeId ).then( () => {

                this.setState( {
                    selectedBaseCode: {},
                    isEdit: false,
                    editId: -1,
                    editMode: '',
                    confirmIsOpen: false,
                } );
                if ( !this.state.searchedText ) {

                    this.handleModeChange( 'SUBSERIES', this.state.currentBaseCode );

                } else {

                    // this.handleSearchChange( this.state.searchedText );

                }
                this.props.decreaseCounter();
                this.props.createSuccessMessage( 'Delete Basecode Successful' );

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else if ( getPreviousMode( this.state.mode ) === 'SERIES' ) {

            this.props.increaseCounter();
            deleteProductSeries( this.props.factoryCode, obj.productSeriesId ).then( () => {

                this.handleModeChange( '', {} );
                this.props.decreaseCounter();
                this.props.createSuccessMessage( 'Delete Product Series Successful' );

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else if ( getPreviousMode( this.state.mode ) === 'SUBSERIES' ) {

            this.props.increaseCounter();
            deleteProductSubSeries( this.props.factoryCode, obj.productSubSeriesId )
                .then( () => {

                    this.handleModeChange( 'SERIES', this.state.currentBaseCode );
                    this.props.decreaseCounter();
                    this.props.createSuccessMessage( 'Delete Product Subseries Successful' );

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

        }

    }

    downLoadReport = () => {

        this.props.increaseCounter();
        const productSeriesId = Object.keys( this.state.currentBaseCode ).length !== 0 ? this.state.currentBaseCode.productSeriesId : '';

        getAdminReport( 'warranty', this.props.factoryCode, productSeriesId )
            .then( response => {

                getAdminReportDownload( response, 'warranty_prodct_structure.csv' );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }
handleDownloadClick = (fileName) => () => {
            console.log("fileName", fileName);
            
            this.props.increaseCounter();
    
            downloadSampleReports(fileName)
                .then(response => {
                    response.blob().then( blob => {
    
                        const url = window.URL.createObjectURL( blob );
                        const a = document.createElement( 'a' );
                        a.setAttribute( 'download', fileName+'.csv' );
                        a.href = url;
                        document.body.appendChild( a );
                        a.click();
                        a.parentNode.removeChild( a );
                
                    } );
                    this.props.decreaseCounter();
                })
                .catch(() => {
                    this.props.decreaseCounter();
                });
        }
    render () {


        return (
            <section>
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">Warranty Product Structure Maintenance
                        <button className="report-button" type="button" onClick={this.downLoadReport}>Download Report</button>
                        {!this.state.isAdd &&
                        <button className="report-button" type="button" onClick={this.onUploadReport}>Upload Report</button> }
                        {/* <a title="Field having values can update only" href={CSVFile} className="upload-report-label" download="warranty_prodct_structure.csv">Download Sample Report</a> */}
                        <a
                        className="upload-report-label"
                        title="Field having values can update only"
                        onClick={this.handleDownloadClick('warranty_prodct_structure')}
                        >
                        Download Sample Report
                    </a>
                    </h2>
                </header>
                <div className="section-with-aside">
                    <main>
                        <SearchBarWidget
                            searchPlaceHolder={this.state.searchPlaceHolder}
                            onSearchTextChange={this.handleSearchChange}
                            searchText={this.state.searchedText}
                        />
                        {this.state.mode !== 'SEARCH' && (
                            <ProductSeriesPanel
                                productList={this.state.baseCodes}
                                mode={this.state.mode}
                                currentBaseCode={this.state.currentBaseCode}
                                handleModeChange={this.handleModeChange.bind( this.props )}
                                handleEditClick={this.handleEditClick.bind( this.props )}
                                handleDeleteClick={this.handleDeleteClick.bind( this.props )}
                                handleBaseCodeSelect={this.handleBaseCodeSelect.bind( this.props )}
                                handleBaseCodeAddClick={this.handleBaseCodeAddClick
                                    .bind( this.props )}
                                baseCodeId={this.state.editId}
                            />
                        )}
                        {this.state.mode === 'SEARCH' && (
                            <BasecodeSearchPanel
                                productList={this.state.baseCodes}
                                mode={this.state.mode}
                                searchedText={this.state.searchedText}
                                handleModeChange={this.handleModeChange.bind( this.props )}
                                handleBaseCodeSelect={this.handleBaseCodeSelect.bind( this.props )}
                                baseCodeId={this.state.editId}
                                id={this.state.id}
                            />
                        )}
                        {/* { this.state.mode === "SEARCH" &&
                        <BaseCodeSearch searchText={this.state.searchText} />} */}
                    </main>
                    <aside>
                        <WPSMAside
                            isEdit={this.state.isEdit}
                            editMode={this.state.editMode}
                            mode={this.state.mode}
                            baseCode={this.state.selectedBaseCode}
                            productserieslist={this.state.productserieslist}
                            productSubSeriesList={this.state.productSubSeriesList}
                            id={this.state.editId}
                            value={this.state.editText}
                            onTextChange={this.handleAsideTextChange}
                            onCancel={this.handleAsideCancel}
                            onUpdate={this.handleAsideUpdate.bind( this.props )}
                            handleDeleteClick={this.handleDeleteClick.bind( this.props )}
                            handleSeriesOnChange={this.handleSeriesOnChange.bind( this.props )}
                            handleSubSeriesOnChange={this.handleSubSeriesOnChange
                                .bind( this.props )}
                            handleBaseCodeAddClick={this.handleBaseCodeAddClick.bind( this.props )}
                            handleBMCNameOnChange={this.handleBMCNameOnChange.bind( this.props )}
                        />
                    </aside>
                    <ConfirmationModal
                        body={(
                            <div className="confirmation-messages">
                                {this.state.confirmMessage}
                            </div>
                        )}
                        header={this.state.confirmTitle}
                        isOpen={this.state.confirmIsOpen}
                        onCancel={this.handleConfirmClose.bind( this.props )}
                        onConfirm={this.handleConfirm.bind( this.props )}
                        onHide={this.handleConfirmClose.bind( this.props )}
                    />
                </div>
                <WarrantyProductStructMultipleEntryPopup
                    isOpen={this.state.modelIsOpen}
                    onClose={this.onUploadReportClose.bind( this.props )}
                />
            </section>
        );

    }

}

WarrantyProductStructureMaintenance.displayName = 'WarrantyProductStructureMaintenance';
WarrantyProductStructureMaintenance.propTypes = {
    factoryCode: PropTypes.string.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    createSuccessMessage: PropTypes.func.isRequired,
    updateReload: PropTypes.func.isRequired,
    reload: PropTypes.string,

};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );

export default connect(
    mapStateToProps, mapDispatchToProps,
)( WarrantyProductStructureMaintenance );
// export default WarrantyProductStructureMaintenance;
